import { FC } from 'react';

const EconansBtn: FC = () => {
  return (
    <div className="lg:bg-blue100 hidden xl:block p-4 xxl:px-6 pt-6 lg:pt-4 xxl:pt-6 w-full">
      <button
        onClick={(e) => {
          const element = document.getElementById('widget');
          const yOffset = -210;
          const y =
            element.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: 'smooth' });
        }}
        className="text-blue700 border-2 border-blue700 py-3 w-full text-center rounded-md font-icb hover-blue-border transform duration-200 block"
      >
        Beräkna din boendekostnad
      </button>
    </div>
  );
};
export default EconansBtn;
